/**
 * Bootstrap nativo Capacitor: inizializzazione status bar + splash screen
 * + hook lifecycle. No-op quando il bundle gira nel browser (PWA/web).
 *
 * Capacitor espone `Capacitor.isNativePlatform()` per distinguere
 * il runtime. Su web ritorna false e i plugin non vengono caricati.
 *
 * I `@ts-ignore` evitano errori in dev su macchine dove `npm install`
 * non ha ancora scaricato `@capacitor/*` (tipico CI/Vercel build, dove
 * questi pacchetti sono usati solo per il build native). I tipi sono
 * comunque corretti dopo l'install.
 */

export async function initNative(): Promise<void> {
  try {
    // @ts-ignore — modulo caricato solo se installato
    const { Capacitor } = await import("@capacitor/core");
    if (!Capacitor.isNativePlatform()) return;

    try {
      // @ts-ignore
      const { StatusBar, Style } = await import("@capacitor/status-bar");
      await StatusBar.setStyle({ style: Style.Light });
      await StatusBar.setBackgroundColor({ color: "#0E7490" });
      // IMPORTANTE: su Capacitor 7+ l'opzione overlaysWebView in
      // capacitor.config.ts NON viene applicata automaticamente su Android.
      // Bisogna chiamarla esplicitamente runtime, altrimenti la WebView
      // si estende SOTTO la status bar e i nostri controls finiscono dietro
      // l'orologio/icone di sistema.
      try {
        await StatusBar.setOverlaysWebView({ overlay: false });
      } catch {
        // setOverlaysWebView e' disponibile solo su Android; su iOS
        // lancia errore "Not implemented" → ignoriamo
      }
    } catch (e) {
      console.warn("StatusBar init failed:", e);
    }

    try {
      // @ts-ignore
      const { SplashScreen } = await import("@capacitor/splash-screen");
      // Nascondi splash dopo che React ha renderizzato la prima schermata
      setTimeout(() => SplashScreen.hide(), 600);
    } catch (e) {
      console.warn("SplashScreen init failed:", e);
    }

    try {
      const { initIap } = await import("./iap");
      await initIap();
    } catch (e) {
      console.warn("IAP init failed:", e);
    }
  } catch {
    // Capacitor non disponibile (web/PWA): no-op
  }
}
